import { ReactElement } from "react";
import { useAppDispatch } from "../app/hooks";
import { setShowRules } from "../app/slices/appSlice";

export const RulesPopup = (): ReactElement => {
  const dispatch = useAppDispatch()

  return (
    <div className={'popup'}>
      <div className={'popup__overflow'} onClick={() => dispatch(setShowRules(false))}></div>
      <div className={'popup__content popup_rules'}>
        <span className={'popup__close'} onClick={() => dispatch(setShowRules(false))}></span>
        <h2 className={'headline'}>Правила</h2>
        <div>
          <p>
            Выжимай цены с помощью кнопки на экране. Если наберешь 1000 кликов — получишь промокод на 1000 при покупке от 5000 рублей, 1500 кликов — промокод на 1500 при покупке от 7500 рублей, а если будет 3000 кликов — промокод на 3000 при покупке от 15000 рублей. Промокоды можно активировать в Мегамаркете.
          </p>
        </div>
        <h2 className={'headline'}>Подробные условия:</h2>
        <div>
          <a target={'_blank'} rel={'noreferrer'} href={'https://megamarket.ru/promo/pravila-akczii-promokod-na-vse-tovary-1000-ot-5000-nb/'} className={'rules__link'}>Промокод 1000 от 5000 на все товары</a>
          <a target={'_blank'} rel={'noreferrer'} href={'https://megamarket.ru/promo/pravila-akczii-promokod-na-vse-tovary-1500-ot-7500-nb/'} className={'rules__link'}>Промокод 1500 от 7500 на все товары</a>
          <a target={'_blank'} rel={'noreferrer'} href={'https://megamarket.ru/promo/pravila-akczii-promokod-na-vse-tovary-3000-ot-15000-nb/'} className={'rules__link'}>Промокод 3000 от 15000 на все товары</a>
        </div>
      </div>
    </div>
  )
}